import { render } from "./UserProfileImage.vue?vue&type=template&id=f40aa35c&ts=true"
import script from "./UserProfileImage.vue?vue&type=script&lang=ts"
export * from "./UserProfileImage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__